import { observable, action, configure, makeObservable } from 'mobx';
import { IEdetector } from '@utils/browserUTLs';

configure({
  enforceActions: 'observed',
  useProxies: IEdetector() ? 'never' : 'always'
});

export interface ScrollBackConfigT {
  previousPage: string;
  positionY: number | null;
  targetHref?: string;
  targetOffsetTop?: number;
}

const defaultConfig: ScrollBackConfigT = {
  previousPage: '',
  positionY: null
};

class Store {
  scrollBackConfig: ScrollBackConfigT = defaultConfig;

  constructor() {
    makeObservable(this, {
      scrollBackConfig: observable,
      setScrollBack: action
    });
  }

  setScrollBack = (newState: ScrollBackConfigT | null): void => {
    this.scrollBackConfig = newState || defaultConfig;
  };
}

const utilsStore = new Store();
export type UtilsStoreType = typeof utilsStore;
export default utilsStore;
